<template>
    <div class="bg-yellow-400 px-1 lg:px-4 py-2 lg:h-16 z-[1000] flex justify-center items-center">
        <div class="container flex justify-between items-center">
            <div class="flex space-x-1 items-start lg:items-center">
                <Icon name="tabler:alert-circle" class="w-6 h-6 text-gray-800" />
                <p class="text-gray-800 lg:text-body-md text-body-sm font-medium leading-5 w-full">
                    Your auto-renewal failed! Please renew your plan to activate your account.
                </p>
            </div>
            <app-button
                variant="primary"
                id="banner-expired-plan-see-plans-button"
                color="white"
                class="text-gray-900 whitespace-nowrap !h-8"
                size="sm"
                @click="redirectHandler"
                >See Plans</app-button
            >
        </div>
    </div>
</template>
<script lang="ts" setup>
const localePath = useLocalePath();
const { mobile } = useResponsive();

const redirectHandler = () => {
    const { fullPath } = useRoute();
    if (fullPath.split("/").includes("dashboard")) {
        window.open("/pricing");
        return;
    }
    useRouter().push(localePath("/pricing"));
};
</script>
